class TVKeyControl {
  constructor(
    KEY_LEFT,
    KEY_RIGHT,
    KEY_UP,
    KEY_DOWN,
    KEY_ENTER,
    KEY_BACK,
    KEY_RETURN,
    KEY_0,
    KEY_1,
    KEY_2,
    KEY_3,
    KEY_4,
    KEY_5,
    KEY_6,
    KEY_7,
    KEY_8,
    KEY_9,
    KEY_RED,
    KEY_GREEN,
    KEY_YELLOW,
    KEY_BLUE,
    KEY_PLAY,
    KEY_PAUSE,
    KEY_STOP,
    KEY_RECORD,
    KEY_FF,
    KEY_RW,
    KEY_PLAY_PAUSE,
    KEY_TOOLS,
    KEY_CH_UP,
    KEY_CH_DOWN,
    KEY_CHLIST,
    KEY_PRECH,
    KEY_TTX_MIX,
    KEY_EXIT,
    KEY_INFO
  ) {
    this.KEY_LEFT = KEY_LEFT;
    this.KEY_RIGHT = KEY_RIGHT;
    this.KEY_UP = KEY_UP;
    this.KEY_DOWN = KEY_DOWN;
    this.KEY_ENTER = KEY_ENTER;
    this.KEY_BACK = KEY_BACK;
    this.KEY_RETURN = KEY_RETURN;
    this.KEY_0 = KEY_0;
    this.KEY_1 = KEY_1;
    this.KEY_2 = KEY_2;
    this.KEY_3 = KEY_3;
    this.KEY_4 = KEY_4;
    this.KEY_5 = KEY_5;
    this.KEY_6 = KEY_6;
    this.KEY_7 = KEY_7;
    this.KEY_8 = KEY_8;
    this.KEY_9 = KEY_9;
    this.KEY_RED = KEY_RED;
    this.KEY_GREEN = KEY_GREEN;
    this.KEY_YELLOW = KEY_YELLOW;
    this.KEY_BLUE = KEY_BLUE;
    this.KEY_PLAY = KEY_PLAY;
    this.KEY_PAUSE = KEY_PAUSE;
    this.KEY_STOP = KEY_STOP;
    this.KEY_RECORD = KEY_RECORD;
    this.KEY_FF = KEY_FF;
    this.KEY_RW = KEY_RW;
    this.KEY_PLAY_PAUSE = KEY_PLAY_PAUSE;
    this.KEY_TOOLS = KEY_TOOLS;
    this.KEY_CH_UP = KEY_CH_UP;
    this.KEY_CH_DOWN = KEY_CH_DOWN;
    this.KEY_CHLIST = KEY_CHLIST;
    this.KEY_PRECH = KEY_PRECH;
    this.KEY_TTX_MIX = KEY_TTX_MIX;
    this.KEY_EXIT = KEY_EXIT;
    this.KEY_INFO = KEY_INFO;
  }
}

export default TVKeyControl;
